import {Component, OnInit} from '@angular/core';
import {RewardHistoryModel} from '../../../shared/models/data.model';
import {RewardService} from '../../../shared/services/reward.service';
import {AuthService} from '../../../shared/services/auth.service';
import {properties} from '../../../../environments/properties';
import {ParamService} from '../../../shared/services/param.service';
import {RewardsSummaryService} from '../../../shared/services/rewards-summary.service';

@Component({
    selector: 'points-history',
    templateUrl: './points-history.component.html',
    styleUrls: ['./points-history.component.scss']
})
export class PointsHistoryComponent implements OnInit {

    public rewardsCount = -1;
    public rewardsHistoryData: RewardHistoryModel = new RewardHistoryModel;
    public rewardsDisplayData: RewardHistoryModel = new RewardHistoryModel;
    public showMoreCount = 0;
    public rewardHistoryDisabled = false;
    public v2Enabled = false;
    public disableEconReceiptURL = true;
    public currentPage = 0;
    banner: any;
    currentEnvironment: any;
    userInfo: any;
    public freshPassUser = false;
    public showPointsScoreCard: boolean;
    private window = window;
    appHostURL: string;
    showLoader = true;
    isErrorOccoured = false;
    tokenCaller = 'points-history';
    isFreshpassRebrand: boolean = false;
    foruBanner: string = '';
    freshpassText: string = '';

    constructor(public rewardService: RewardService, public authService: AuthService, public paramService: ParamService, private _rewardSummaryService: RewardsSummaryService) {
    }

    ngOnInit(): void {
        this._init(false)
    }
    _init(reloaded) {
        this.isErrorOccoured = false;
        this.appHostURL = this.authService.getApplicationDomainURL();
        this.banner = this.paramService.banner;
        this.currentEnvironment = this.rewardService.getEnvironment();
        this.v2Enabled = properties.rewardsConfig.v2Enabled;
        this.disableEconReceiptURL = properties.rewardsConfig.disableEconReceiptURL;
        this.showPointsScoreCard = true;
        this.isFreshpassRebrand = properties.rewardsConfig.freshpassRebranding;
        this.foruBanner = properties.rewardsConfig.foruBanner.replace('banner', properties.rewardsConfig.displaybleBannerNames[this.banner]);
        this.freshpassText = properties.rewardsConfig.freshpassText;
        this.getUserInfo();
        setTimeout(function(){
            (document.getElementById("back-button-pdp") as HTMLElement).focus();
        },100)

        if (window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].initAngularSPA) {
            window['AB']['DATALAYER'].initAngularSPA('rewards', 'points-history');
        }
    }
    getUserInfo() {
        this.authService.pointsHistorySessionData$.subscribe((userInfo) => {
            if (userInfo) {
                this.userInfo = userInfo;
                if (userInfo.isTokenValid) {
                    this.getFreshPassStatus()
                } else {
                    this.authService.redirectToSSO(userInfo.tokenObject);
                }
            } else {
                this.authService.getUserLogedInToken(this.tokenCaller);
            }
        });
    }

    public getFreshPassStatus(){
        this._rewardSummaryService.getFreshpassSubscription(this.currentEnvironment, this.userInfo).subscribe((data: any) => {
            if (data && data.Data) {
                this.freshPassUser = (data.Data.subscriptionStatus === 'ACTIVE' || data.Data.subscriptionStatus === 'TRIAL');
                this.getPointsHistory();

            } else {
                this.freshPassUser = false;
                this.getPointsHistory();
            }
        }, error => {
            this.freshPassUser = false;
            this.getPointsHistory();
        })
    }

    public getPointsHistory() {
        this.rewardService.getPointsHistory(this.currentPage, this.currentEnvironment, this.userInfo).subscribe(data => {
            try {
                if(data && data.hhid) {
                    this.rewardsHistoryData.hhid = data.hhid;
                    const {pageSize, pageNumber, totalElements, totalPages} = data.pageable || {};

                    const newHistories = JSON.parse(JSON.stringify(data.transactionHistories));
                    const oldHistories = this.rewardsDisplayData.transactionHistories ? this.rewardsDisplayData.transactionHistories.slice(0, pageSize * pageNumber) : [];

                    this.rewardsDisplayData.transactionHistories = [...oldHistories, ...newHistories];
                    this.rewardsCount = totalElements;
                    this.showMoreCount = (totalPages > pageNumber + 1) ? 10 : 0;
                    this.showLoader = false;
                    if(this.currentPage > 0){
                        let lastItem = ((this.currentPage) * 10) - 1;
                        let nextFocusItem = document.getElementById(`item-${lastItem}`);
                        if(nextFocusItem){
                            nextFocusItem.setAttribute('tabindex', '-1');
                            setTimeout(function(){
                                (nextFocusItem as HTMLElement).focus();
                            },100);
                        }
                    }
                } else {
                    this.rewardsCount = 0;
                    this.showMoreCount = 0;
                    this.showLoader = false;
                }

            } catch (e) {
                this.isErrorOccoured = true;
                this.showMoreCount = 0;
                this.showLoader = false;
            }

        }, error => {
            this.isErrorOccoured = true;
            this.showMoreCount = 0;
            this.showLoader = false;

        });
    }

    public showMore(event) {

        if (this.v2Enabled) {
            this.currentPage += 1;
            this.getPointsHistory();
        } else {
            this.rewardsCount += this.showMoreCount;
            this.showMoreCount = Math.min(10, this.rewardsHistoryData.transactionHistories.length - this.rewardsCount);
            this.rewardsDisplayData.transactionHistories = JSON.parse(JSON.stringify(this.rewardsHistoryData.transactionHistories.slice(0, this.rewardsCount)));
        }
    }

    public formatRewards(type: string, rewards: string, isTotal: boolean = false): string {
        let formattedRewards = '';
        const modifiedType = type ? type : '';
        if(rewards) {
            formattedRewards += (modifiedType.toLowerCase() == 'earn') ? "+" : '';
            formattedRewards += rewards;
            if (parseInt(rewards) == 1) {
                formattedRewards += this.v2Enabled ? isTotal ? " Total Reward" : " Reward" : " reward";
            } else {
                formattedRewards += this.v2Enabled ? isTotal ? " Total Rewards" : " Rewards" : " rewards";
            }
        }
        return formattedRewards;
    }

    public formatV3PointsRewards(type: string, activity :any, isTotal: boolean = false): string {
        let formattedRewards = '';
        let isPoint = false;
        let isRewards = false;
        let value = 0;
        if(activity && activity.rewards && activity.rewards !== 0) {
            isRewards = true;
        } else {
            isPoint = true;
        }
        const modifiedType = type ? type : '';
        formattedRewards += (modifiedType.toLowerCase() === 'earn') ? '+' : '';
        if(isPoint) {
            value = activity.points;
            formattedRewards += value;
            if (value === 1) {
                formattedRewards += this.v2Enabled ? isTotal ? ' Total Points' : ' Point' : ' point';
            } else {
                formattedRewards += this.v2Enabled ? isTotal ? ' Total Points' : ' Points' : ' points';
            }
        } else {
            value = activity.rewards;
            formattedRewards += value;
            if (value === 1) {
                formattedRewards += this.v2Enabled ? isTotal ? ' Total Reward' : ' Reward' : ' reward';
            } else {
                formattedRewards += this.v2Enabled ? isTotal ? ' Total Rewards' : ' Rewards' : ' rewards';
            }
        }
        return formattedRewards;
    }

    public formatPoints(type: string, points: string, isTotal: boolean = false): string {

        let formattedPoints = '';
        const modifiedType = type ? type : '';
        if(points) {
            formattedPoints += (modifiedType.toLowerCase() == 'earn') ? "+" : '';
            formattedPoints += points;
            if (parseInt(points) == 1) {
                formattedPoints += this.v2Enabled ? isTotal ? " Total Point" : " Point" : " point";
            } else {
                formattedPoints += this.v2Enabled ? isTotal ? " Total Points" : " Points" : " points";
            }
        }
        return formattedPoints;
    }
    public formatDisplayRewards(type, record, isTotal): string {

        let formattedRewards = '';
        const modifiedType = type ? type : '';
        let rewards;
        if(record.eventSource.toLowerCase() == 'expiration' || record.eventSource.toLowerCase() == 'expiry-reward' || record.eventSource.toLowerCase() == 'expiry-points') {
            rewards = record.activity.rewards;
        } else {
            rewards = record.totalBalance.rewards;
        }
        if(rewards !== undefined) {
            formattedRewards += (modifiedType.toLowerCase() == 'earn') ? "+" : '';
            formattedRewards += rewards;
            if (parseInt(rewards) == 1) {
                formattedRewards += this.v2Enabled ? isTotal ? " Total Reward" : " Reward" : " reward";
            } else {
                formattedRewards += this.v2Enabled ? isTotal ? " Total Rewards" : " Rewards" : " rewards";
            }
        }
        return formattedRewards;
    }
    public formatDisplayPoints(type, record, isTotal): string {

        let formattedPoints = '';
        const modifiedType = type ? type : '';
        let points;
        if(record.eventSource.toLowerCase() == 'expiration' || record.eventSource.toLowerCase() == 'expiry-reward' || record.eventSource.toLowerCase() == 'expiry-points') {
            points = record.activity.points;
        } else {
            points = record.totalBalance.points;
        }
        if(points !== undefined) {
            formattedPoints += (modifiedType.toLowerCase() == 'earn') ? "+" : '';
            formattedPoints += points;
            if (parseInt(points) == 1) {
                formattedPoints += this.v2Enabled ? isTotal ? " Total Point" : " Point" : " point";
            } else {
                formattedPoints += this.v2Enabled ? isTotal ? " Total Points" : " Points" : " points";
            }
        }
        return formattedPoints;
    }
    public formatEventSource(str: string): string {
        return str.toLowerCase().replace(/(\b\w)/g, function (firstLetter) {
            return firstLetter.toUpperCase();
        });
    }

    public formatFuelTransactionDetail(discountPerGallon: string, partner: string): string {
        return discountPerGallon.replace(/\b\w+\b(\s+\b\w+\b){1}\s*$/, '/ gal. off at ' + partner);
    }

    public formatExpire(str: string): string {
        return `${str} Expire`;
    }

    public isDisplayable(value): boolean {
        return (parseInt(value, 10) > 0 || parseInt(value, 10) < 0);
    }

    public isDisplayableTotal(value): boolean {
        return (parseInt(value, 10) >= 0);
    }

    public isExpiration(event: string): boolean {
        return (event.toLowerCase() === 'expiration' || event.toLowerCase() === 'expiry-reward' || event.toLowerCase() == 'expiry-points');
    }

    public ecomOrderReceiptFlag(receiptInfo: any): boolean {
        if (this.disableEconReceiptURL) {
            if ((receiptInfo.lane === '099' || parseInt(receiptInfo.lane, 10) === 99) && receiptInfo.transactionNbr.length > 4) {
                return false;
            }
        }
        return true;
    }

    public setReceiptURL(receiptInfo: any, eventSource: any): string {

        if(eventSource === 'Auto Cash Off Redemption' && (receiptInfo.lane === '099' || parseInt(receiptInfo.lane, 10) === 99)){
            // Auto cash Redemption Receipt URL and lane == 99
            return '/customer-account/payment.html?orderId=' + receiptInfo.altTransactionNbr;

        }else if (eventSource !== 'Auto Cash Off Redemption' && (receiptInfo.lane === '099' || parseInt(receiptInfo.lane, 10) === 99) && receiptInfo.transactionNbr.length > 4) {
            // ecom receipt URL
            return '/customer-account/payment.html?orderId=' + receiptInfo.transactionNbr;
        }
        // store receipt URL
        return '/customer-account/payment.html?storeId=' + receiptInfo.store + '&laneNumber=' + parseInt(receiptInfo.lane, 10) + '&sequenceNumber=' + parseInt(receiptInfo.transactionNbr, 10) + '&date=' + receiptInfo.date;
    }

    openRewardsPage() {
        this.window.location.href ='/rewards/dashboard';
    }

    reLoadPage() {
        this._init(true);
    }
}
